export default __webpack_public_path__ + "images/33f268a9cf642a425f825f4f4fea5018-emoji-sick.svg";